module.exports = __webpack_public_path__ + "assets/d6dc07f8f1a3a9e70c74b19f63d136f0.png";